import { IAlertProvider } from '@addins/core/core';
import { MyLocationService } from '@addins/core/map';
import { Injectable } from '@angular/core';
import { Coordinates } from '@awesome-cordova-plugins/geolocation/ngx';
import { Coordinate } from '@models/coordinate';
import { PhoneCreateEventRes } from '@models/imported/SagaBase/PhoneCreateEventRes';
import { MobEvents } from '@models/imported/TW/Saga/Core/Base/Mobile/MobEvents';
import { SagaSettingsService } from '@services/settings';
import { MyEquipmentService } from '@techwan/ionic-core';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { ICreateCardRequest } from '../../schema/interfaces/create-card-request';
import { EventsProviderService } from '../events-provider/events-provider.service';

@Injectable()
export class EventFactoryService implements IAlertProvider {
  constructor(
    private eventsProvider: EventsProviderService,
    private myEquipment: MyEquipmentService,
    private myLocation: MyLocationService,
    private sagaSettings: SagaSettingsService
  ) {}

  canCreate(): Observable<boolean> {
    return this.sagaSettings.$ready.pipe(
      filter(isReady => isReady),
      switchMap(() => this.eventsProvider.whenReady().pipe(filter(isReady => isReady))),
      map(() => this.eventsProvider.getEmergency() !== null)
    );
  }

  create(event?: MobEvents): Observable<PhoneCreateEventRes> {
    return this.eventsProvider.create(this.createRequestData(event), this.getTimestamp());
  }

  getHoldTimeout(): number {
    return this.sagaSettings.getValue('SagaMobileWebClient.TapHoldThreshold') as number;
  }

  private createRequestData(event: MobEvents): ICreateCardRequest {
    const myLocation = this.getLocation();

    if (event === null) {
      event = this.eventsProvider.getEmergency();
    }
    const isAlarm: boolean = event.Isemergency === true;
    const callerLastName: string = isAlarm ? this.myEquipment.myDevice.Name : this.myEquipment.myUnit.Name;

    return {
      coordX: myLocation.x,
      coordY: myLocation.y,
      epsg: myLocation.epsg,
      eventId: event.EvtEventId,
      callerLastName: callerLastName
    };
  }

  private getLocation(): Coordinate {
    const coords: Coordinates = this.myLocation.mostRecent?.coords;
    return coords ? { x: coords.longitude, y: coords.latitude, epsg: this.myLocation.WSG84_EPSG } : this.myLocation.defaultCoordinate;
  }

  private getTimestamp(): number {
    return (this.myLocation.mostRecent && this.myLocation.mostRecent.timestamp) || Date.now();
  }
}
